import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6 ModelField-colFirst" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1)
const _hoisted_5 = { class: "col-6 ModelField-colLast" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Тип транспорта", -1)
const _hoisted_7 = { style: {"margin-top":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_EnumControl = _resolveComponent("EnumControl")!
  const _component_TractorCreateEditDialog = _resolveComponent("TractorCreateEditDialog")!
  const _component_ContainerCreateEditDialog = _resolveComponent("ContainerCreateEditDialog")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    height: _ctx.isContainer ? '870px' : _ctx.tractorSettingsVisibility ? '950px' : '865px',
    onSaveData: _ctx.saveData,
    maxWidth: "1000px",
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_DxTextBox, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Наименование...",
                "show-clear-button": true,
                value: model.name,
                "onUpdate:value": ($event: any) => ((model.name) = $event)
              }, null, 8, ["value", "onUpdate:value"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_EnumControl, {
                class: "ModelField-control",
                id: model.transportType,
                "onUpdate:id": ($event: any) => ((model.transportType) = $event),
                desc: model.transportTypeDescription,
                "onUpdate:desc": ($event: any) => ((model.transportTypeDescription) = $event),
                enumType: "transportType",
                stylingMode: "outlined",
                onChanged: _ctx.onTypeChange
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "onChanged"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.isTractor)
            ? (_openBlock(), _createBlock(_component_TractorCreateEditDialog, {
                key: 0,
                ref: "tractorCreateEditDialog",
                model: model,
                validationGroup: validationGroup,
                onChangeSettingsVisibility: _ctx.changeSettingsVisibility
              }, null, 8, ["model", "validationGroup", "onChangeSettingsVisibility"]))
            : _createCommentVNode("", true),
          (_ctx.isContainer)
            ? (_openBlock(), _createBlock(_component_ContainerCreateEditDialog, {
                key: 1,
                model: model,
                validationGroup: validationGroup
              }, null, 8, ["model", "validationGroup"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "height", "onSaveData"]))
}